import _get from 'lodash/get';
import _set from 'lodash/set';
import assert from 'http-assert-plus';

export function createStore(data) {
  data = JSON.parse(JSON.stringify(data));

  const getValue = key => {
    assert(typeof key === 'string', new TypeError('Expected getValue key to be a string'));
    return _get(data, key, null);
  };
  const setValue = (key, value) => {
    assert(typeof key === 'string', new TypeError('Expected setValue key to be a string'));

    const before = JSON.stringify(getValue(key));
    const after = JSON.stringify(value);

    if (before !== after) {
      _set(data, key, JSON.parse(after));
      this.$emit('input', JSON.parse(JSON.stringify(data)));
      this.$emit('update', { key, value: JSON.parse(after) });
      return true;
    } else {
      return false;
    }
  };

  return {
    getValue,
    setValue,
  };
}



// WEBPACK FOOTER //
// ./src/lib/manage.js